import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  private searchTermSubject = new BehaviorSubject<string>('');
  private searchInputSubject = new Subject<string>();
  
  /** Observable com debounce de 1 segundo - use este para fazer requisições */
  public searchTerm$: Observable<string>;
  
  /** Observable sem debounce - use para atualizar UI imediatamente */
  public searchTermImmediate$: Observable<string> = this.searchTermSubject.asObservable();

  /** Indica se o campo de busca deve estar aberto */
  private searchOpenSubject = new BehaviorSubject<boolean>(false);
  public searchOpen$: Observable<boolean> = this.searchOpenSubject.asObservable();

  constructor() {
    // Configura o debounce de 1 segundo
    this.searchTerm$ = this.searchInputSubject.pipe(
      debounceTime(1000),
      distinctUntilChanged()
    );
    
    // Também atualiza o BehaviorSubject após o debounce
    this.searchTerm$.subscribe(term => {
      this.searchTermSubject.next(term);
    });
  }

  setSearchTerm(term: string): void {
    this.searchInputSubject.next(term);
  }

  /**
   * Define o termo de busca imediatamente (sem debounce)
   * e opcionalmente abre o campo de busca
   */
  setSearchTermImmediate(term: string, openSearch: boolean = false): void {
    this.searchTermSubject.next(term);
    this.searchInputSubject.next(term);
    if (openSearch) {
      this.searchOpenSubject.next(true);
    }
  }

  setSearchOpen(open: boolean): void {
    this.searchOpenSubject.next(open);
  }

  getSearchTerm(): string {
    return this.searchTermSubject.getValue();
  }
}
